import { ChangeDetectionStrategy, Component, computed, effect, inject, input, output, signal, untracked} from '@angular/core';
import { FieldTextComponent, FieldNumberComponent, FieldSelectComponent, AbstractFormArrayComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { TableModule } from "primeng/table";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { OrganizationListComponent } from "../../../organizations/components/organization-list/organization-list";
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { startWith, switchMap } from 'rxjs';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { EntityApiEnum, EtiquetteApiEnum, ModelApiEnum } from 'src/app/config/entity-api.enum';
import { Tool } from '../../models/tool.model';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-position-tools-form',
  providers:[],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, Button, TableModule, CommonModule, FormsModule, FieldTextComponent, FieldNumberComponent, FieldSelectComponent, OrganizationListComponent],
  templateUrl: './position-tools-form.html'
})

export class PositionToolsFormComponent extends AbstractFormArrayComponent{
  private readonly formFactory = inject(FormFactoryService);
  public readonly organizationStore = inject(OrganizationStoreService);

  workingPhase=input.required<number>();
  showRequest =input.required<boolean>();
  addRow = output<void>();
  deleteRow = output<number>();
  calculateTotal = output<number>();
  createRequest = output<Tool>();

  equipmentApi= EntityApiEnum.EQUIPMENT;
  equipmentEtiquetteApi= EtiquetteApiEnum.EQUIPMENT;  
  equipmentModelApi = ModelApiEnum.EQUIPMENT;

  equipmentForm = this.formFactory.createEquipmentForm();
  selectedRow = signal<any>(undefined);

  showCost=computed(()=>{
    const workingPhase =this.workingPhase();
    return workingPhase==1;
  });


  private readonly formValues = toSignal(
    toObservable(this.form).pipe(
      switchMap(array => array.valueChanges.pipe(
        startWith(array.getRawValue())
      ))
    )
  );
  
  constructor() {
    super();

    effect(() => {
      const currentValues = this.formValues();
      const isEditing = !this.isFormDisabled();

      if (isEditing && currentValues) {
        let total = 0;

        this.form().controls.forEach((control, index) => {
          const rowValue = currentValues[index];
          if (!rowValue) return;

          const costControl = control.get('cost');
          total += Number(costControl?.value ?? 0);
        });

        untracked(() => {
          this.calculateTotal.emit(total);
        });
      }
    });
  }

}
  